import { Link } from 'react-router-dom';
import { Instagram, Twitter } from 'lucide-react';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img
                src="/inklogo_transparent.png"
                alt="Ink & Innovation Printworks"
                className="h-28 w-auto"
              />
            </Link>
            <p className="text-white/50 max-w-md mb-8 leading-relaxed">
              An independent publishing house dedicated to stories that illuminate the human experience. 
              We believe in the power of literature to transform, connect, and inspire.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-white/10 hover:border-gold text-white/50 hover:text-gold transition-all duration-300"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-white/10 hover:border-gold text-white/50 hover:text-gold transition-all duration-300"
                data-testid="social-twitter"
                aria-label="Twitter"
              >
                <Twitter size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Links Column */}
          <div>
            <h4 className="overline text-gold mb-6">Explore</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/books" className="text-white/50 hover:text-white transition-colors" data-testid="footer-books">
                  Bookstore
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/50 hover:text-white transition-colors" data-testid="footer-about">
                  Publishing House
                </Link>
              </li>
              <li>
                <Link to="/author" className="text-white/50 hover:text-white transition-colors" data-testid="footer-author">
                  About the Author
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-white/50 hover:text-white transition-colors" data-testid="footer-blog">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/50 hover:text-white transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="overline text-gold mb-6">Stay Connected</h4>
            <p className="text-white/50 text-sm mb-6">
              Subscribe for new releases, events, and literary musings.
            </p>
            <NewsletterForm />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-sm">
            © {new Date().getFullYear()} Ink and Innovation. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-white/30 hover:text-white/50 transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/30 hover:text-white/50 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
